import { ValueOfKey } from '../../../utils-types';

export const PATH_TYPE = {
  EXTERNAL_LINK: 'EXTERNAL_LINK',
  LOCAL_PATH: 'LOCAL_PATH',
} as const;

export type PathType = ValueOfKey<typeof PATH_TYPE>;

export const SIDEBAR_ITEM_TYPE = {
  LINK: 'LINK',
  SOLUTION: 'SOLUTION',
  GROUP: 'GROUP',
  COLLAPSE_MENU: 'COLLAPSE_MENU',
  MENU: 'MENU',
} as const;

export type SidebarItemType = ValueOfKey<typeof SIDEBAR_ITEM_TYPE>;
